import { useState, useEffect } from "react";

const PRIZES = [
  { label: "200 Free Spins", color: "#f59e0b", affiliate: "https://fgrns.lynmonkel.com/?mid=389405_2246229", casino: "5Gringos" },
  { label: "CA$1,000 Bonus", color: "#a855f7", affiliate: "https://1weucj.life/casino/list?open=register&p=pvsd", casino: "1Win" },
  { label: "150 Free Spins", color: "#ef4444", affiliate: "https://top.aglobally.com/redirect.aspx?pid=4960&bid=1466&lpid=6", casino: "HellSpin" },
  { label: "Try Again", color: "#374151", affiliate: null, casino: null },
  { label: "CA$500 Bonus", color: "#22c55e", affiliate: "https://fairspin-h.click/62639/8406", casino: "Fairspin" },
  { label: "400 Free Spins", color: "#3b82f6", affiliate: "https://tvohyjpmb.com/sport/casino/ca_en/coin_volcano2/", casino: "Mostbet" },
  { label: "CA$1,500 Bonus", color: "#ec4899", affiliate: "https://vulkanvegas-promo.com/l/69b09766a52f4256800c1002", casino: "Vulkan Vegas" },
  { label: "50 Free Spins", color: "#f97316", affiliate: "https://ntrfr.leovegas.com/redirect.aspx?pid=3658838&bid=18372", casino: "LeoVegas" },
];

const TOTAL = PRIZES.length;
const ARC = (2 * Math.PI) / TOTAL;

export default function LuckySpinPopup() {
  const [visible, setVisible] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [result, setResult] = useState(null);
  const [phase, setPhase] = useState("spin"); // spin | result

  useEffect(() => {
    const shown = sessionStorage.getItem("spinShown");
    if (!shown) {
      const t = setTimeout(() => {
        setVisible(true);
        sessionStorage.setItem("spinShown", "1");
      }, 5000);
      return () => clearTimeout(t);
    }
  }, []);

  const spin = () => {
    if (spinning) return;
    // Never land on "Try Again" (index 3) - pick random prize
    const prizes = [0,1,2,4,5,6,7];
    const idx = prizes[Math.floor(Math.random() * prizes.length)];
    const targetAngle = 360 * 8 + (360 - idx * (360 / TOTAL)) - (360 / TOTAL / 2);
    setSpinning(true);
    setRotation(prev => prev + targetAngle);
    setTimeout(() => {
      setSpinning(false);
      setResult(PRIZES[idx]);
      setPhase("result");
    }, 4000);
  };

  if (!visible) return null;

  return (
    <div style={{position:"fixed",inset:0,zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,0.85)",backdropFilter:"blur(4px)"}}>
      <div style={{background:"linear-gradient(135deg,#1a0533,#2d0a5e)",border:"2px solid rgba(168,85,247,0.4)",borderRadius:"24px",padding:"32px",maxWidth:"480px",width:"90%",textAlign:"center",position:"relative",boxShadow:"0 0 60px rgba(168,85,247,0.3)"}}>
        
        {/* Close */}
        <button onClick={() => setVisible(false)} style={{position:"absolute",top:"12px",right:"16px",background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontSize:"1.4rem",cursor:"pointer"}}>✕</button>

        {phase === "spin" ? (
          <>
            <div style={{fontSize:"2rem",marginBottom:"8px"}}>🎰</div>
            <h2 style={{color:"white",fontSize:"1.5rem",fontWeight:"bold",marginBottom:"4px"}}>Spin & Win!</h2>
            <p style={{color:"rgba(255,255,255,0.5)",fontSize:"0.85rem",marginBottom:"24px"}}>Exclusive bonus just for you — spin to reveal!</p>

            {/* Wheel */}
            <div style={{position:"relative",width:"260px",height:"260px",margin:"0 auto 24px"}}>
              {/* Pointer */}
              <div style={{position:"absolute",top:"-16px",left:"50%",transform:"translateX(-50%)",zIndex:10,fontSize:"1.8rem",filter:"drop-shadow(0 2px 4px rgba(0,0,0,0.5))"}}>▼</div>
              
              <svg width="260" height="260" style={{transform:`rotate(${rotation}deg)`,transition:spinning?"transform 4s cubic-bezier(0.17,0.67,0.12,0.99)":"none",borderRadius:"50%",boxShadow:"0 0 30px rgba(168,85,247,0.4)"}}>
                {PRIZES.map((prize, i) => {
                  const startAngle = i * ARC - Math.PI/2;
                  const endAngle = startAngle + ARC;
                  const x1 = 130 + 125 * Math.cos(startAngle);
                  const y1 = 130 + 125 * Math.sin(startAngle);
                  const x2 = 130 + 125 * Math.cos(endAngle);
                  const y2 = 130 + 125 * Math.sin(endAngle);
                  const mx = 130 + 75 * Math.cos(startAngle + ARC/2);
                  const my = 130 + 75 * Math.sin(startAngle + ARC/2);
                  const words = prize.label.split(" ");
                  return (
                    <g key={i}>
                      <path d={`M130,130 L${x1},${y1} A125,125 0 0,1 ${x2},${y2} Z`} fill={prize.color} stroke="#1a0533" strokeWidth="2"/>
                      <text x={mx} y={my} textAnchor="middle" fill="white" fontSize="9" fontWeight="bold" transform={`rotate(${(i * 360/TOTAL) + 360/TOTAL/2},${mx},${my})`}>
                        {words.map((w,wi) => <tspan key={wi} x={mx} dy={wi===0?"-5":"11"}>{w}</tspan>)}
                      </text>
                    </g>
                  );
                })}
                <circle cx="130" cy="130" r="18" fill="#1a0533" stroke="rgba(168,85,247,0.6)" strokeWidth="3"/>
                <text x="130" y="135" textAnchor="middle" fill="#a855f7" fontSize="16">🎰</text>
              </svg>
            </div>

            <button onClick={spin} disabled={spinning} style={{background:spinning?"#374151":"linear-gradient(135deg,#a855f7,#7c3aed)",color:"white",border:"none",borderRadius:"100px",padding:"14px 40px",fontSize:"1.1rem",fontWeight:"bold",cursor:spinning?"not-allowed":"pointer",width:"100%",transition:"all 0.2s"}}>
              {spinning ? "Spinning... 🎰" : "🎰 SPIN NOW — It's Free!"}
            </button>
            <p style={{color:"rgba(255,255,255,0.3)",fontSize:"0.7rem",marginTop:"10px"}}>18+ | T&Cs Apply | One spin per session</p>
          </>
        ) : (
          <>
            <div style={{fontSize:"3rem",marginBottom:"12px"}}>🎉</div>
            <h2 style={{color:"#ffd700",fontSize:"1.8rem",fontWeight:"bold",marginBottom:"8px"}}>You Won!</h2>
            <div style={{background:`${result.color}22`,border:`2px solid ${result.color}`,borderRadius:"16px",padding:"20px",marginBottom:"20px"}}>
              <div style={{color:result.color,fontSize:"1.6rem",fontWeight:"bold"}}>{result.label}</div>
              <div style={{color:"rgba(255,255,255,0.5)",fontSize:"0.85rem",marginTop:"4px"}}>at {result.casino}</div>
            </div>
            <a href={result.affiliate} target="_blank" rel="noopener noreferrer" style={{display:"block",textDecoration:"none"}}>
              <button style={{background:"linear-gradient(135deg,#ffd700,#f59e0b)",color:"black",border:"none",borderRadius:"100px",padding:"16px",fontSize:"1.1rem",fontWeight:"bold",cursor:"pointer",width:"100%",marginBottom:"10px"}}>
                🎁 Claim My {result.label} →
              </button>
            </a>
            <button onClick={() => setVisible(false)} style={{background:"transparent",border:"1px solid rgba(255,255,255,0.2)",color:"rgba(255,255,255,0.4)",borderRadius:"100px",padding:"10px",fontSize:"0.85rem",cursor:"pointer",width:"100%"}}>
              No thanks
            </button>
          </>
        )}
      </div>
    </div>
  );
}
